

export enum CustomSearchType {
  simple,
  complex
}
